import { defineMessages } from 'react-intl'

export default defineMessages({
  title: { defaultMessage: 'They sent Bobas and said...' },
})
